import axios from 'axios';
import apiLogger from '../apiLogger';
import { VIMEO_AUTHERIZATION, VIMEO_BASE_URL } from './Vimeo_Constant';

export const Vimeo_axios_adapter = axios.create({
    baseURL: VIMEO_BASE_URL,
    timeout: 60 * 1000,
    headers: {
        'Content-Type': 'application/json',
    },
});

Vimeo_axios_adapter.interceptors.request.use(
    (config) => {
       config.headers['Authorization'] = `${VIMEO_AUTHERIZATION}`;
        return config;
    },
    (error) => {
        return apiLogger.error(error);
    }
);

Vimeo_axios_adapter.interceptors.response.use(
    (response) => {
        return apiLogger.response(response);
    },
    (error) => {
        return apiLogger.error(error);
    }
);
